import { render, staticRenderFns } from "./ExpensesHeader.vue?vue&type=template&id=758261d2&scoped=true&"
import script from "./ExpensesHeader.vue?vue&type=script&lang=js&"
export * from "./ExpensesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758261d2",
  null
  
)

export default component.exports